module.exports = __webpack_public_path__ + "./kit/docs/img/icon-buffer.96f13e1847ee3819e42a8bd3a245eb58.svg";